import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Router} from 'react-router-dom';
import {createStructuredSelector} from 'reselect';

import AppLoaderRaw from '../../components/Loader/AppLoader/AppLoadeRaw';
import appConfig from '../../config/appConfig';
import appService from '../../services/app/appService';
import history from '../../services/history';
import {initLocalizations} from '../../services/localization/localizationService';
import log from '../../services/logger/log';
import appRouterService from '../../services/route/appRouterService';
import userDeviceService from '../../services/user/userDeviceService';
import {hideLoader, setIsAppLoaded} from '../../state/ducks/global';
import {makeIsAppLoading} from '../../state/selectors/global';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import Routes from '../Routes/Routes';

const mapStateToProps = createStructuredSelector({
    isAppLoading: makeIsAppLoading(),
});

const App = (props) => {
    const {isAppLoading, dispatch} = props;
    const onInit = async () => {
        const isBleSupported = userDeviceService.isBluetoothSupported();

        if (appConfig.getIsMarketInitialized()) {
            await appService.initializeStartActions();
            appService.forwardToInitialPage();
        } else {
            await initLocalizations();

            if (appConfig.getIsMarketDetected()) {
                appRouterService.forwardToNotAvailablePage();
            } else {
                appRouterService.forwardToCannotDetectLocationPage();
            }
        }

        log.info(`App: app is started successfully, isBleSupported: ${isBleSupported}`);

        dispatch(setIsAppLoaded());

        if (!isBleSupported) {
            dispatch(hideLoader());
        }
    };

    useEffect(() => {
        onInit();
    }, []);

    return (
        <ErrorBoundary>
            {isAppLoading ? (
                <AppLoaderRaw />
            ) : (
                <Router history={history.getHistory()}>
                    <Routes />
                </Router>
            )}
        </ErrorBoundary>
    );
};

export default connect(mapStateToProps)(App);
